import { Zone } from './zone';
import { Ville } from './ville';

export class Adresse {

    id: string;
    ref: string;
    ref_metier: string;
    nom_batiment: string;
    street_number: string;
    route: string;
    postal_code: string;
    sublocality: string;
    locality: string;
    country: string;
    country_code: string;
    computed_address: string;
    pay_id: string;
    zon_id: string;
    vil_id: string;
    zne_id: string;
    publier: string;
    zones: Zone[];
    ville: Ville;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                 = data['id'] ? data['id'] : null;
        this.ref                = data['ref'] ? data['ref'] : null;
        this.ref_metier         = data['ref_metier'] ? data['ref_metier'] : null;
        this.nom_batiment       = data['nom_batiment'] ? data['nom_batiment'] : null;
        this.street_number      = data['street_number'] ? data['street_number'] : null;
        this.route              = data['route'] ? data['route'] : null;
        this.postal_code        = data['postal_code'] ? data['postal_code'] : null;
        this.sublocality        = data['sublocality'] ? data['sublocality'] : null;
        this.locality           = data['locality'] ? data['locality'] : null;
        this.country            = data['country'] ? data['country'] : null;
        this.country_code       = data['country_code'] ? data['country_code'] : null;
        this.computed_address   = data['computed_address'] ? data['computed_address'] : null;
        this.pay_id             = data['pay_id'] ? data['pay_id'] : null;
        this.zon_id             = data['zon_id'] ? data['zon_id'] : null;
        this.vil_id             = data['vil_id'] ? data['vil_id'] : null;
        this.zne_id             = data['zne_id'] ? data['zne_id'] : null;
        this.publier            = data['publier'] ? data['publier'] : null;
        this.ville              = new Ville(data['ville'] ? data['ville'] : null);

        this.zones  = [];
        if (data['zones'] && data['zones'].length > 0) {
            data['zones'].forEach(element => {
                this.zones.push(new Zone(element));
            });
        }
    }

}
